  <p-fieldset [legend]="'LABELS.OFFLINE_LICENSE_KEY' | translate" *ngIf="offlineLicenseKey" class="clean-fieldset text-color-secondary adapt">
    <div class="flex align-items-center gap-2">

      <button
        pButton
        class="p-button-rounded p-button-text p-button-plain"
        [class.p-button-secondary]="!copied"
        [class.p-button-success]="copied"
        [label]="(copied ? 'LABELS.COPIED' : '') | translate"
        [icon]="copied ? 'fa-solid fa-circle-check' : 'fa-solid fa-copy'"
        [pTooltip]="(copied ? '' : 'LABELS.COPY') | translate"
        (click)="onCopy()"
      ></button>
      <button pButton class="p-button-rounded p-button-text p-button-plain" icon="fa-solid fa-download" (click)="downloadLicenseFile()" [pTooltip]="'BUTTONS.DOWNLOAD_OFFLINE_KEY' | translate"></button>
      <button *ngIf="showRenewOfflineLicenseKeyButton" pButton class="p-button-rounded p-button-text p-button-plain" icon="fa-solid fa-sync" (click)="renewOfflineLicenseKey()" [pTooltip]="'BUTTONS.REGENERATE_OFFLINE_LICENSE' | translate"></button>
    </div>
  </p-fieldset>
